import { Locator } from '@/lib/test.locators';

export const dialogLocatorMap = [
  {
    type: 'string',
    element: 'h2',
    id: 'dialogTitle',
    property: 'dialog-title',
  },
  {
    type: 'string',
    element: 'button',
    id: 'dialogConfirmBtn',
    property: 'dialog-confirmation-add',
  },
  {
    type: 'string',
    element: 'div',
    id: 'dialogCloseOverlay',
    property: 'dialog-close-overlay',
  },
  {
    type: 'string',
    element: 'button',
    id: 'dialogCloseBtn',
    property: 'dialog-close',
  },
  {
    type: 'string',
    element: 'button',
    id: 'dialogConfirmationCloseBtn',
    property: 'dialog-confirmation-close',
  },
  {
    type: 'string',
    element: 'div',
    id: 'dialogConfirmationDesc',
    property: 'dialog-confirmation-description',
  },
] as const;

type DialogLocatorId = Locator<typeof dialogLocatorMap>;

export const dialogLocators: Record<DialogLocatorId, string> = dialogLocatorMap.reduce(
  (acc, { id, property }) => {
    acc[id] = property;
    return acc;
  },
  {} as Record<DialogLocatorId, string>,
);
